export const SELECT_MODEL = "SELECT_MODEL";
export const LOAD_MODEL_LIST = "LOAD_MODEL_LIST";
export const LOAD_MODEL_LIST_FULLFILL = "LOAD_MODEL_LIST_FULLFILL";
export const LOAD_MODEL_LIST_FAILED = "LOAD_MODEL_LIST_FAILED";
export const LOAD_MODEL = "LOAD_MODEL";
export const LOAD_MODEL_FULLFILL = "LOAD_MODEL_FULLFILL";
export const LOAD_MODEL_FAILED = "LOAD_MODEL_FAILED";
export const UPDATE_CANVAS = "UPDATE_CANVAS"
export const PROCESS_CANVAS = "PROCESS_CANVAS";
export const PROCESS_CANVAS_FULLFILL = "PROCESS_CANVAS_FULLFILL";
export const PROCESS_CANVAS_FAILED = "PROCESS_CANVAS_FAILED";